// api/properties.ts - PropertiesController endpoints

import { AxiosResponse } from 'axios';
import $api from './instance';
import {
  IProperty,
  AddPropertyValues,
  UpdatePropertyRequest,
  FetchAllPropertiesResponse,
  IUser,
} from '@/types';
import {
  PropertiesSearchParams,
  PropertiesApiResponse
} from '@/types/api-types';

// === PROPERTIES API ===

/**
 * Отримати список properties з фільтрацією та пагінацією (НОВИЙ API)
 */
export async function getPropertiesRequest(
  params?: PropertiesSearchParams,
): Promise<AxiosResponse<PropertiesApiResponse>> {
  const searchParams = new URLSearchParams();

  if (params) {
    for (const key in params) {
      if (Object.prototype.hasOwnProperty.call(params, key)) {
        const value = params[key];
        // Исключаем служебные параметры, которые API ожидает в другом формате
        if (key === 'sortBy' && value) {
          searchParams.set('sortBy', String(value));
        } else if (key === 'sortDirection' && value) {
          searchParams.set('sortDirection', String(value));
        } else if (key === 'page' && value) {
          searchParams.set('page', String(value));
        } else if (key === 'limit' && value) {
          searchParams.set('limit', String(value));
        }
        // Добавляем все остальные параметры, если они имеют значение
        else if (value !== undefined && value !== null && value !== '') {
          searchParams.set(key, String(value));
        }
      }
    }
  }

  const queryString = searchParams.toString();
  const url = queryString ? `/properties?${queryString}` : '/properties';

  return $api.get<PropertiesApiResponse>(url);
}

/**
 * LEGACY: Отримати список properties (стара версія для зворотної сумісності)
 */
export async function getPropertiesRequestLegacy(): Promise<
  AxiosResponse<FetchAllPropertiesResponse>
> {
  return $api.get<FetchAllPropertiesResponse>('/properties');
}

/**
 * Отримати одну property за ID
 */
export async function getPropertyRequest(id: number): Promise<IProperty> {
  const response = await $api.get<IProperty>(`/properties/${id}`);
  return response.data; // Повертаємо тільки дані, не весь AxiosResponse
}

/**
 * Створити нову property
 */
export async function createPropertyRequest(
  data: AddPropertyValues,
): Promise<AxiosResponse<IProperty>> {
  return $api.post<IProperty>('/properties', data);
}

/**
 * Оновити property
 */
export async function updatePropertyRequest({
                                              id,
                                              data,
                                            }: UpdatePropertyRequest): Promise<AxiosResponse<IProperty>> {
  return $api.patch<IProperty>(`/properties/${id}`, data);
}

/**
 * Видалити property
 */
export async function deletePropertyRequest(
  id: number,
): Promise<AxiosResponse<void>> {
  return $api.delete(`/properties/${id}`);
}

/**
 * Отримати профіль учасника (tenant/manager) в контексті property
 */
export async function getParticipantProfile(
  propertyId: number,
  userId: number,
): Promise<AxiosResponse<IUser>> {
  return $api.get(`/properties/${propertyId}/profile/${userId}`);
}
